import { t } from "@ebay/i18n-ebay";
import type { MapContext } from "../map/types";
$ const {
  banners,
  bannerInsertPositions,
  showErrorMessage,
  feedItems,
  isLoading,
  pointsOfInterest,
  highlightedItem,
  selectedItems,
  isWatchlistPillActive,
} = input;
$ const loadingItems = new Array(9).fill("");

<context|ctx| from="map">
  $ const { handleWatchListItemToggle, watchListItems } = (ctx || {}) as MapContext;

  <div class="items-feed" data-testid="items-feed">
    <if(isLoading)>
      <ul>
        <for|_value, index| of=loadingItems>
          <div class="items-feed-loading items-feed__item-wrapper" key=String(`loading-feed-item-${index}`)>
            <div class="loading-feed-item-image-container">
              <ebay-skeleton style={ height: "auto", width: "100%" }>
                <ebay-skeleton-image/>
              </ebay-skeleton>
            </div>
            <div/>
            <ebay-skeleton>
              <ebay-skeleton-text style={ width: "100%" }/>
            </ebay-skeleton>
          </div>
        </for>
      </ul>
    </if>
    <if(feedItems?.length > 0 && !showErrorMessage && !isLoading)>
      <ul>
        <for|item, index| of=feedItems>
          <if(item.itemCard)>
            $ const originalIndex = pointsOfInterest.findIndex((poi) => poi.itemCard?.card?.listingId === item.itemCard?.card?.listingId);
            $ const isHighlighted = highlightedItem === originalIndex;
            $ const isSelected = selectedItems.indexOf(originalIndex) !== -1;
            $ const isVisible = feedItems.some((feedItem) => item.itemCard?.card.listingId === feedItem.itemCard?.card.listingId);
            <feed-item
              selectionState=(isSelected ? "selected" : isHighlighted ? "highlighted" : "unselected")
              isVisible=isVisible
              on-item-hover("onItemHover")
              on-unhover-item("onUnhoverItem")
              index=originalIndex
              model=item.itemCard
              handleWatchListItemToggle=handleWatchListItemToggle
              watchListItems=watchListItems
            />
          </if>
          <if(!isWatchlistPillActive)>
            <feed-banners bannerInsertPositions=bannerInsertPositions currentIndex=index feedItemsLength=feedItems.length banners=banners/>
          </if>
        </for>
      </ul>
    </if>
    <if((feedItems?.length < 1 || showErrorMessage) && !isLoading)>
      <div class="items-feed-no-results" data-testid="feed-no-results">

        <p class="items-feed-no-results__title">
          <fe-textual-display model=t("mapview/map", isWatchlistPillActive ? "watchlistEmptyMessage" : "noResultsTitle")/>
        </p>
        <if(!isWatchlistPillActive)>
          <p class="items-feed-no-results__subtitle">
            <fe-textual-display model=t("mapview/map", "noResultsMessage")/>
          </p>
        </if>
      </div>
    </if>
  </div>
</context>
